module.exports = __webpack_public_path__ + "2954d949f7f632980246c76eb640261e.fbx";